var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb-16", staticStyle: { "margin-bottom": "24px" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("purchase::purchase-list::quick_sort"))),
              ]),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "purchase--order__quickSort",
                  model: {
                    value: _vm.statusList,
                    callback: function ($$v) {
                      _vm.statusList = $$v
                    },
                    expression: "statusList",
                  },
                },
                _vm._l(_vm.controlStatus, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(" " + _vm._s(item.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c("z-search", {
            ref: "purchase",
            attrs: { configs: _vm.listConfigs },
            on: { "do-query": _vm.query },
            model: {
              value: _vm.searchData,
              callback: function ($$v) {
                _vm.searchData = $$v
              },
              expression: "searchData",
            },
          }),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt10" },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "mb-16" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "purchase::purchase-list::purchase-add",
                        expression: "'purchase::purchase-list::purchase-add'",
                      },
                    ],
                    attrs: { icon: "el-icon-plus", type: "primary" },
                    on: { click: _vm.addPurchaseOrder },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("purchase::purchase-list::add_supplier")
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c("z-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              columns: _vm.orderColumns,
              data: _vm.lists,
              "max-height": 550,
              pagination: _vm.pagination,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.handlePageChange,
            },
            scopedSlots: _vm._u([
              {
                key: "purchaseNo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$dataCheck(row.purchaseNo))),
                    ]),
                    row
                      ? _c("el-progress", {
                          attrs: {
                            percentage: _vm.progress(row),
                            color: "#70b603",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "createInfo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("purchase::purchase-list::creator")) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.createName))
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("purchase::purchase-list::create_time")) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.createTime))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "auditInfo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("purchase::purchase-list::auditor")) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.auditorName))
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("purchase::purchase-list::audit_time")) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.auditTime))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "reviewInfo",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("purchase::purchase-list::re_auditor")) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.reviewerName))
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("purchase::purchase-list::re_audit_time")
                        ) +
                          "：" +
                          _vm._s(_vm.$dataCheck(row.reviewTime))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "purchaseStatusName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("i", {
                      staticClass: "round",
                      style: {
                        background: _vm.statusToColor[row.purchaseStatus],
                      },
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.PRUCHASE_STATUS[row.purchaseStatus])),
                    ]),
                  ]
                },
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.purchaseStatus === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::examine",
                                expression:
                                  "'purchase::purchase-list::examine'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::audit")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    row.purchaseStatus === 2
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::re-examine",
                                expression:
                                  "'purchase::purchase-list::re-examine'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::re_audit")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    row.purchaseStatus !== 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value:
                                  "purchase::purchase-list::purchase-detail",
                                expression:
                                  "'purchase::purchase-list::purchase-detail'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "/purchase/detail/" + row.id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::detail")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    row.purchaseStatus === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::purchase-edit",
                                expression:
                                  "'purchase::purchase-list::purchase-edit'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push(
                                  "/purchase/edit/" + row.id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::edit")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    [3, 4, 5].some(function (i) {
                      return i === row.purchaseStatus
                    })
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::in-stock",
                                expression:
                                  "'purchase::purchase-list::in-stock'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::in_stock")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    [2, 3].some(function (i) {
                      return i === row.purchaseStatus
                    })
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::close",
                                expression: "'purchase::purchase-list::close'",
                              },
                            ],
                            staticStyle: { color: "#d9001b" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 4)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::close")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    row.purchaseStatus === 1
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::delete",
                                expression: "'purchase::purchase-list::delete'",
                              },
                            ],
                            staticStyle: { color: "#d9001b" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 5)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::delete")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    [4, 5].some(function (i) {
                      return i === row.purchaseStatus
                    })
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "purchase::purchase-list::complete",
                                expression:
                                  "'purchase::purchase-list::complete'",
                              },
                            ],
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openDialog(row, 6)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("purchase::purchase-list::finished")
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "500px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { "font-size": "18px" },
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _vm.editRow.editType !== 3
                ? _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: { color: "#999", "margin-right": "10px" },
                  })
                : _vm._e(),
              _vm.editRow.editType === 1
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::audit_confirm"))
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 2
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("purchase::purchase-list::re_audit_confirm")
                      )
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 3
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("purchase::purchase-list::purchase_in_stock")
                      )
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 4
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("purchase::purchase-list::close_purchase_order")
                      )
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 5
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::purchase_delete"))
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 6
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("purchase::purchase-list::purchase_finished")
                      )
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            [
              _vm.editRow.editType !== 3
                ? _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("purchase::purchase-list::puechase_order_num")
                        ) +
                        "：" +
                        _vm._s(_vm.editRow.purchaseNo) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 4
                ? _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::close_confirm"))
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 5
                ? _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::delete_confirm"))
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 6
                ? _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("purchase::purchase-list::setting_confirm"))
                    ),
                  ])
                : _vm._e(),
              _vm.editRow.editType === 3
                ? _vm._l(_vm.editRow.list, function (item) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "sku-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "sku-wrap" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: { src: item.img },
                            }),
                            _c("div", { staticClass: "sku-info" }, [
                              _c("p", { staticClass: "spu-name one-line" }, [
                                _vm._v(_vm._s(item.spuName)),
                              ]),
                              _c("p", [_vm._v("SKU: " + _vm._s(item.skuId))]),
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "purchase::purchase-list::purchase_amount"
                                      )
                                    ) +
                                    "：" +
                                    _vm._s(item.skuBuyQuantity) +
                                    " "
                                ),
                                _c("span", { staticClass: "array-number" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "purchase::purchase-list::arrival_amount"
                                        )
                                      ) +
                                      "：" +
                                      _vm._s(item.skuArrivalQuantity) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "purchase::purchase-list::in_stock_this_time_num"
                              ),
                            },
                            model: {
                              value: item.qty,
                              callback: function ($$v) {
                                _vm.$set(item, "qty", $$v)
                              },
                              expression: "item.qty",
                            },
                          },
                          [
                            _c("template", { slot: "prepend" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "purchase::purchase-list::in_stock_this_time"
                                  )
                                )
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  })
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("purchase::purchase-list::cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.editOrder } },
                [_vm._v(_vm._s(_vm.$t("purchase::purchase-list::confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }